import React from "react";
import PropTypes from "prop-types";
import FAQAccordionItem from "components/atoms/FAQAccordionItem";
import SectionHeader from "components/molecules/SectionHeader";
import faqIcon from "assets/icons/psp/faq-icon.svg";
import "./FAQSection.scss";
import Container from "components/core/Page/Container";
import markdownToText from "utils/renderMarkdownToText";

const FAQSection = ({ title, description = null, faqs, className = "" }) => {
	const faqList = Array.isArray(faqs) ? faqs : [];
	// FAQ list is static and does not change after mount, so memoization is unnecessary.
	const faqSchema = faqList.length
		? JSON.stringify({
				"@context": "https://schema.org",
				"@type": "FAQPage",
				mainEntity: faqList.map((faq) => ({
					"@type": "Question",
					name: faq.question,
					acceptedAnswer: {
						"@type": "Answer",
						text: markdownToText(faq.answer)
					}
				}))
			})
		: null;

	return (
		<section className={`storage-faq-section ${className || ""}`}>
			{faqSchema && (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: faqSchema }}
				/>
			)}
			<Container>
				<SectionHeader
					image={faqIcon}
					title={title}
					description={description}
					className="storage-faq-section__header"
					contentAlign="text-left"
					additionalProps={{
						paragraph: { size: "large", mediumSize: "standard" }
					}}
				/>
				<div className="storage-faq-section__accordion-list">
					{faqs?.map((faq) => (
						<FAQAccordionItem
							key={`faq-${faq.question}`}
							question={faq.question}
							answer={faq.answer}
							defaultOpen={faq.defaultOpen || false}
						/>
					))}
				</div>
			</Container>
		</section>
	);
};

FAQSection.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	faqs: PropTypes.arrayOf(
		PropTypes.shape({
			question: PropTypes.string.isRequired,
			answer: PropTypes.string.isRequired,
			defaultOpen: PropTypes.bool
		})
	).isRequired,
	className: PropTypes.string
};

export default FAQSection;
